import { useEffect } from "react";
import { useDispatch } from "react-redux";
import AddProject from "../components/addProject";
import useCustomState from "../hooks/State";
import { UpdateNavigations } from "../store/actions";

const ProjectAdd = (props) => {
  const isLoading = useCustomState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const navigations = [{ name: "افزودن پروژه", path: "/admin/add-project" }];
    dispatch(UpdateNavigations(navigations));
    isLoading.handleChange(false);
  }, []);

  if (!isLoading.value) {
    return (
      <>
        <AddProject />
      </>
    );
  } else {
    return null;
  }
};

export default ProjectAdd;
